import React from 'react';
import { TabsHeaderContainer, TabButton } from './styles';

export default function TabsHeader({ activeTab, onChange }) {
  return (
    <TabsHeaderContainer>
      <TabButton
        type="button"
        $active={activeTab === 'connection'}
        onClick={() => onChange('connection')}
      >
        Conexão
      </TabButton>
      <TabButton
        type="button"
        $active={activeTab === 'ai'}
        onClick={() => onChange('ai')}
      >
        Inteligência Artificial
      </TabButton>
    </TabsHeaderContainer>
  );
}
